// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gOMj","right":"styles_right__trGkE"};